module.exports = __webpack_public_path__ + "img/fredrik-solli-wandem-vkvuSqAah80-unsplash.a511bdfe.jpeg";